module.exports = __webpack_public_path__ + "static/5-281440b256d8bf526d79615ec8a1cff5.png";